import { EquipmentModel } from '../interfaces/equipment.interface';
import { InterimModel } from '../interfaces/interim.interface';

export const isInterimExistInEquipments = (interims: InterimModel[], equipments: EquipmentModel[]): boolean => {
    return interims.some(
        (interim) => interim.Equipment && equipments.some((equipment) => equipment.EquipmentHq === interim.Equipment),
    );
};
